// Arcade's narrowing of the contract's open-ended clip-name space.
//
// deform-clip-set/v0 keeps clip names as plain strings by design — "which loops
// an actor has is the CONTENT's business". The host declares the set it actually
// switches between, and the Actor state machine maps States onto these.
//
// 'talk' is the standing-NPC vocabulary (Order 16.6): a combat actor never plays
// it, so CLIP_NAMES — the set a COMBAT rig must bake — deliberately excludes it.
// NPC rigs declare their own required set (anim/npc-clipset.ts).

export type ClipName = 'idle' | 'walk' | 'jump' | 'attack' | 'hit' | 'talk';

export const CLIP_NAMES: readonly ClipName[] = ['idle', 'walk', 'jump', 'attack', 'hit'];
